import { Layout, Wallet, Globe, BarChart3, ShieldCheck, HeadphonesIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

const FeaturesSection = () => {
    const { t } = useTranslation();

    const features = [
        {
            icon: <Layout className="text-african-accent" size={24} />,
            title: t('landing.features.creation.title'),
            description: t('landing.features.creation.desc'),
        },
        {
            icon: <Wallet className="text-african-accent" size={24} />,
            title: t('landing.features.monetization.title'),
            description: t('landing.features.monetization.desc'),
        },
        {
            icon: <Globe className="text-african-accent" size={24} />,
            title: t('landing.features.audience.title'),
            description: t('landing.features.audience.desc'),
        },
        {
            icon: <BarChart3 className="text-african-accent" size={24} />,
            title: t('landing.features.analytics.title'),
            description: t('landing.features.analytics.desc'),
        },
        {
            icon: <ShieldCheck className="text-african-accent" size={24} />,
            title: t('landing.features.protection.title'),
            description: t('landing.features.protection.desc'),
        },
        {
            icon: <HeadphonesIcon className="text-african-accent" size={24} />,
            title: t('landing.features.support.title'),
            description: t('landing.features.support.desc'),
        },
    ];

    return (
        <section id="features" className="py-24 bg-card relative overflow-hidden animate-fade-up">
            {/* Background elements */}
            <div className="absolute top-0 right-0 w-1/3 h-full bg-african-accent/5 -skew-x-12 transform origin-top-right -z-0" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-20 animate-fade-up">
                    <span className="text-african-accent font-bold tracking-wider uppercase text-sm">{t('landing.features.badge')}</span>
                    <h2 className="font-display text-4xl sm:text-5xl font-bold mt-4 mb-6">
                        {t('landing.features.title')} <span className="text-african-accent">{t('landing.features.titleAccent')}</span>
                    </h2>
                    <p className="text-xl text-muted-foreground">
                        {t('landing.features.subtitle')}
                    </p>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="bg-background p-8 rounded-2xl border border-border hover:border-african-accent/50 hover:shadow-medium transition-all duration-300 group animate-fade-up"
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <div className="w-14 h-14 bg-african-accent/10 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                                {feature.icon}
                            </div>
                            <h3 className="text-xl font-bold mb-4">{feature.title}</h3>
                            <p className="text-muted-foreground leading-relaxed">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;
